import { useState, useEffect } from "react";
import Select from 'react-select';

const CboSeccion = ({ selectedValue, onChange, disabled, grupo, empresa, grusu, className }) => {

  const [secciones, setSecciones] = useState([]);

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.grusu = grusu;
    console.log("Inicio CboSeccion", grupo, empresa, selectedValue);
    jsons3 = JSON.stringify(consulta);

    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/sec/allsecciones`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        setSecciones(json3.data);
        if (json3.data.length > 0) {
          var primerId;
          if (selectedValue) {
            primerId = selectedValue;
          }
          else {
            primerId = json3.data[0].Sec_IdSec;
          }

          // Creamos un objeto que simule el evento de cambio para no romper la lógica del componente padre
          const eventoSimulado = {
            target: {
              value: primerId
            }
          };
          onChange(eventoSimulado);
        }

      })


  }, [grupo, empresa, selectedValue]);


  const opcionesSecciones = [
    { value: 0, label: 'todas las secciones' },

    ...secciones.map((unolista) => ({
      value: unolista.Sec_IdSec,
      label: unolista.Sec_Nombre
    }))
  ];

  const seccionSeleccionada =
    opcionesSecciones.find(op => op.value === selectedValue);


  return (

    /* </label>
  
            <select key={selectedValue} className={`form-control form-select mb-3 ${className} `} value={String(selectedValue)} onChange={onChange} disabled={disabled}  >
  
              {secciones.map((unolista, index) => (
                <option key={unolista.Sec_IdSec} value={String(unolista.Sec_IdSec)}  >{unolista.Sec_Nombre}</option>
              )
              )
              }
            </select> */

    <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4">
      <div className="form-group">
        <label className="l">
          Sección
        </label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesSecciones}
          value={seccionSeleccionada}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion.value || 0
              }
            })
          }
          isDisabled={disabled}
        />

      </div>
    </div>

  );
};

export default CboSeccion;